import React from "react";
import {TextField} from "@mui/material";
import {fieldSx} from "../../editMenuStyles";

export const UserInputSettings = ({node, onUpdate, onChangeData}) => (
    <>
        <TextField
            value={node?.data?.duration || ""}
            size="small"
            type="number"
            label="User Speaking Duration"
            placeholder="Enter maximum speaking duration in seconds"
            helperText="Specify how long the user is allowed to speak before processing the input."
            sx={fieldSx}
            onChange={(e) => onChangeData("duration", e?.target?.value ? +e?.target?.value : "")}
            onBlur={() => onUpdate(node)}
        />
        <TextField
            value={node?.data?.silence || ""}
            size="small"
            type="number"
            label="Silence Timeout"
            placeholder="Enter silence duration before processing input"
            helperText="Set the time (in seconds) to wait after the user stops speaking before sending the message."
            sx={fieldSx}
            onChange={(e) => onChangeData("silence", e?.target?.value ? +e?.target?.value : "")}
            onBlur={() => onUpdate(node)}
        />
    </>
);
